import { render, staticRenderFns } from "./ProprietaryPortfolioTableRow.vue?vue&type=template&id=3185f420&scoped=true"
import script from "./ProprietaryPortfolioTableRow.vue?vue&type=script&lang=js"
export * from "./ProprietaryPortfolioTableRow.vue?vue&type=script&lang=js"
import style0 from "./ProprietaryPortfolioTableRow.vue?vue&type=style&index=0&id=3185f420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3185f420",
  null
  
)

export default component.exports